angular.module("boyds").directive('pageLoadingSpinner', ['config', function (config) {
    return {
        restrict: 'E',
        templateUrl: config.templates.pageLoadingSpinner.url
    };
}]);